import _axios from '@/services/axios';
import { DepositType } from '@/types/deposit.type';
import { Component, Vue } from 'vue-property-decorator';
import WithRender from './deposit.html';
import config from "@/settings/config.js";

@WithRender
@Component({
})
export default class Deposit extends Vue {
    [x: string]: any;
    depositType: DepositType = {} as DepositType;
    display = true;
    username = "";
    ewalletto = "";
    fullName ="";
    busy = false;
    processing = false;
    depositOptions = [
        { value: '', text: 'Please select an option' },
        { value: 'atm', text: 'Cash deposited at ATM' },
        { value: 'ewallet', text: 'Ewallet' },
        { value: 'collected', text: 'Cash collected in person' },
        { value: 'bank', text: 'Bank Transfer' },
        { value: 'credit', text: 'Credit Advance' },
        { value: 'referral', text: 'Referral Payment' }
    ]

    currencyOptions = [
        { value: 'R', text: 'Rand' },
        { value: 'MWK', text: 'Malawi Kwacha' },
        { value: 'USD', text: 'US Dollar' }
    ]

    reflectingInBankOptions = [
        { value: '', text: 'Please select an option' },
        { value: true, text: 'Yes' },
        { value: false, text: 'No' }
    ]
    onSubmit() {
        this.processing = false
        this.busy = true
    };

    onCancel() {
        this.busy = false
    };

    onOK() {
        this.counter = 1
        this.processing = true
        this.onDeposit();
    }

    mounted() {
        this.depositType.userId = this.$route.params.userId as string;
        const username = this.$route.params.username as string;
        const email = this.$route.params.email as string;
        this.depositType.fullName = this.$route.params.fullName as string;
        this.depositType.currency ="R";
        if (username) {
            this.depositType.userName = username;
            this.username = username;
        }
        else {
            this.depositType.userName = email;
        }
    }

    async onDeposit() {
        try {
            if (this.ewalletto.trim() != "")
                this.depositType.comment += " | " + this.ewalletto;
            const response = await _axios.post(`${config.gateway}credits/deposit/DepositRequest`, this.depositType);
            this.userDetails = response.data;
            this.$router.push("unapproved");
        } catch (error) {
            this.$bvToast.toast(error.response.data, {
                title: 'Notification',
                variant: 'danger',
                autoHideDelay: 5000,
            });
            this.busy = false;
            this.processing = false;
        }
    }
}

